window.addEventListener('load', () => {
  /**
   * if embedding some needs a script, add the link of the script here. The script is added to header of DOM
   * in function loadScript()
   */
  const scriptLinks = {
    facebook: `https://connect.facebook.net/${themeDisplay.getLanguageId()}/sdk.js#xfbml=1&version=v12.0`,
    twitter: 'https://platform.twitter.com/widgets.js',
    instagram: 'https://www.instagram.com/embed.js'
  }

  const elemIframes = document.querySelectorAll('IFRAME:not([src*="mihinsrkkuulun.evlutkirkko.fi"])')
  const twitterContainers = document.querySelectorAll('.twitter-timeline')
  const twitterScripts = document.querySelectorAll('.twitter-script')
  const videoFrames = document.querySelectorAll('.video-container')

  const cookieConsentIframeBanners = document.querySelectorAll('.cookieconsent-iframebanner')
  const cookieConsentAcceptIframes = document.querySelectorAll('.cookieconsent-acceptiframes')

  /**
   * @description if accepting personalization, scroll all iframes and allow personalisation material
   */
  function handleIframeBannerButtons () {
    const bannerBtnTxt = document.querySelector('#iframe-banners-btn').innerText
    const bannerDisclaimerTxt = document.querySelector('#iframe-banners-txt').innerText
    const youtubeHighLight = document.querySelectorAll('.embed-responsive-16by9')
    const allBannerTxt = document.querySelectorAll('.iframe-banner-txt')
    const elemLink = document.createElement('A')

    /**
     * @description for Youtube-videos: add name of the video on banner
     * @param {String} link link of the youtube video
     */
    function youtubeHeader (link) {
      const myRegexp = /embed\/(.*)/
      const videoId = myRegexp.exec(link)[1]
      const url = 'https://www.youtube.com/watch?v=' + videoId.split('?')[0]

      $.getJSON('https://noembed.com/embed', { format: 'json', url: url }, function (data) {
        elemLink.innerHTML = data.title
      })
    }

    /**
     * @description add click event for consent buttons
     * @param {ELEMENT<button>} btn HTML-element consent button
     */
    function consentCookies (btn) {
      btn.addEventListener('click', function () {
        localStorage.setItem('personalization', 'true')
        location.reload(true)
      })
    }

    /**
     * @description Append cookie consent banner to content and link highlight portlets start of the body
     */
    const appendCookieAcceptPortletStart = (iframe) => {
      const portletBody = $(iframe).closest('div .portlet-body')
      const cookieBannerContainer = $(portletBody).find('.portlet-cookie-consent-container')

      //if there is only map-iframe, don't add cookie banner to portlet-body since it is allowed always
      if (elemIframes.length === 1 &&
          (iframe.parentElement.classList.contains('places-map') ||
          iframe.parentElement.classList.contains('map-container'))) {
          return;
      }

      if (cookieBannerContainer.children().length <= 0) {
        cookieBannerContainer.removeClass('d-none')
        cookieBannerContainer.addClass('mb-4')
        cookieBannerContainer.removeAttr('aria-hidden')

        cookieBannerContainer.append(createElementBanner())
      }
    };

    /**
     * @description create banner on iframes
     * @returns HTML-element
     */
    function createElementBanner () {
      const cookiebanner = document.createElement('DIV')
      const cookiebannerContentHolder = document.createElement('DIV')
      const cookiebannerBannerTxt = document.createElement('P')
      const cookiebannerButtonHolder = document.createElement('DIV')
      const cookiebannerBannerBtn = document.createElement('BUTTON')

      cookiebanner.classList.add(
        'cookieconsent-iframebanner',
        'justify-content-center',
        'align-items-end',
        'py-2'
      )
      cookiebannerContentHolder.classList.add('d-flex', 'flex-wrap')
      cookiebannerBannerTxt.classList.add('iframe-banner-txt', 'pl-0', 'col-12')
      cookiebannerBannerTxt.innerText = bannerDisclaimerTxt
      cookiebannerBannerBtn.innerText = bannerBtnTxt
      cookiebannerButtonHolder.classList.add('pl-0', 'col-12')
      cookiebannerBannerBtn.classList.add(
        'cookieconsent-acceptiframes',
        'btn',
        'btn-primary',
        'btn-cookie-settings',
        'bg--primary'
      )

      cookiebannerButtonHolder.appendChild(cookiebannerBannerBtn)
      cookiebannerContentHolder.appendChild(cookiebannerBannerTxt)
      cookiebannerContentHolder.appendChild(cookiebannerButtonHolder)
      cookiebanner.appendChild(cookiebannerContentHolder)
      consentCookies(cookiebannerBannerBtn)

      return cookiebanner.appendChild(cookiebannerContentHolder)
    }

    Array.from(cookieConsentAcceptIframes).forEach((e) => {
      e.innerText = bannerBtnTxt
      consentCookies(e)
    })

    // add placeholder/general description for all banners
    Array.from(allBannerTxt).forEach((e) => {
      e.innerText = bannerDisclaimerTxt
    })

    /**
     * check target of each iframe and handle blocking content as needed.
     */
    Array.from(elemIframes).forEach((e) => {
      if (e.dataset.src) {
        if (e.dataset.src.includes('youtube')) {
          elemLink.href = e.dataset.src
          elemLink.classList.add('link-ext', 'color--primary')

          youtubeHeader(e.dataset.src)
          if (!e.querySelector('A')) {
            e.parentElement.querySelector('.iframe-banner-txt').after(elemLink)
          }
        }
        if (e.parentElement.classList.contains('video-container')) {
          // if (e.parentElement.classList.contains('video-container')) {
          e.parentElement.classList.remove('video-container')
          e.parentElement.querySelector('IFRAME').style.height = ''
          appendCookieAcceptPortletStart(e);
          // }
        }
      }

      // maps made w embed tools
      if (
        e.parentElement.classList.contains('places-map') ||
        e.parentElement.classList.contains('map-container')
      ) {
        e.style.height = e.height
        e.style.pointerEvents = 'initial'
      } else {
        e.style.height = '0px'
        e.style.pointerEvents = 'none'
        e.style.overflow = 'initial'
      }

      //

      if (!e.parentElement.querySelector('.cookieconsent-iframebanner') && (e.parentElement.className !== 'g-recaptcha')) {
        appendCookieAcceptPortletStart(e)
      }
    })

    /**
     *
     */
    Array.from(videoFrames).forEach((videoFrame) => {
      const videoName = videoFrame.querySelector('IFRAME').dataset.src
      const myRegexp = /embed\/(.*)/
      if (videoName) {
        if (videoName.includes('youtube')) {
          const videoId = myRegexp.exec(videoName)[1]
          const url = 'https://www.youtube.com/watch?v=' + videoId

          videoFrame.style.paddingBottom = '0px'
          videoFrame.style.overflow = 'initial'
          videoFrame.style.height = 'initial'
          videoFrame.classList.add('video-container-inactive')
          $.getJSON('https://noembed.com/embed', { format: 'json', url: url }, function (data) {
            if (data.title && videoFrame.querySelector('A')) {
              videoFrame.querySelector('A').innerHTML = data.title
            }
          })
        } else {
          if (videoFrame.parentElement.classList.contains('video-container')) {
            videoFrame.parentElement.classList.remove('video-container')
            videoFrame.parentElement.querySelector('IFRAME').style.height = '0'
          }
        }
      }
    })

    Array.from(youtubeHighLight).forEach((e) => {
      e.classList.remove('embed-responsive')
      e.querySelector('IFRAME').style.height = '0'
    })

    Array.from(cookieConsentAcceptIframes).forEach((e) => {
      e.addEventListener('click', function () {
        e.removeAttribute('aria-hidden')
        Array.from(cookieConsentIframeBanners).forEach((e) => {
          e.classList.add('d-none')
        })
      })
    })
  }

  /**
   * @description handle banners if consent is accepted
   */
  function removeBlockingBanners () {
    // general iframes (user made)
    Array.from(elemIframes).forEach((e) => {
      if (e.dataset.src) {
        e.src = e.dataset.src
      }
      if (e.dataset.href) {
        e.href = e.dataset.href
      }
    })

    // kiha-embeds
    Array.from(cookieConsentIframeBanners).forEach((e) => {
      e.classList.add('d-none')
      Array.from(videoFrames).forEach((e) => {
        e.querySelector('IFRAME').src = e.querySelector('IFRAME').dataset.src
      })
    })

    Array.from(twitterContainers).forEach((e) => {
      e.href = e.dataset.href
    })

    Array.from(twitterScripts).forEach((e) => {
      e.src = e.dataset.src
    })

    Array.from(cookieConsentAcceptIframes).forEach((e) => {
      e.setAttribute('aria-hidden', 'true')
    })

    /**
     * @description If embed needs a script, load it if cookies are accepted eg. facebook, Twitter
     * @param { <String> } src script link
     */
    function loadScript (src) {
      let script = document.createElement('script')
      script.src = src
      script.async = false
      script.crossorigin = 'anonymous'
      document.body.append(script)
    }

    for (const link in scriptLinks) {
      loadScript(scriptLinks[link])
    }
  }

  /**
   * INIT CONTENT HANDLING
   * check, if cookies are accepted
   */
  if (cookieConsentIframeBanners) {
    if (JSON.parse(localStorage.getItem('personalization')) === true) {
      removeBlockingBanners()
    } else {
      handleIframeBannerButtons()
    }
  }
})
